/**
 * subject-selector-modal.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, OnInit } from "@angular/core";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";
import { Observable } from "rxjs/Rx";

import { Subject } from "./subject";
import { SubjectContextType } from "./subject-context-type";
import { UserService } from "app/auth/identity/user.service";
// import { SubjectService } from "./subject.service";

export type SelectionMode = "recent" | "search" | "watchlist";
export interface SubjectSelectionContext extends BSModalContext
{
  list : Subject[];
  mode : SelectionMode;
  onlyOfType? : SubjectContextType;
  title : string;
  showNonLoaded? : boolean;
  actionLabel? : string;
}

@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      {{dialog.context.title || "Subjects"}}
    </h4>
  </div>

  <table
    *ngIf="dialog.context.mode === 'recent'"
    class="table center-items" width="100%">
    <thead>
      <tr>
        <th>
          Type
        </th>
        <th>
          Name
        </th>
        <th>
          Status
        </th>
        <th>
          Last Action*
        </th>
        <th *ngIf="users.debugMode">
          IDs
        </th>
        <th *ngIf="provideAction"><!-- empty --></th>
      </tr>
    </thead>

    <tbody>
      <tr *ngIf="!subjects?.length">
        <td colspan="10">
          <h3 class="text-center">No recent subjects!</h3>
        <td>
      </tr>
      <tr *ngFor="let subj of subjects">
        <td>
          {{subj.type}}
        </td>
        <td>
          {{subj.readableTitle}}
        </td>
        <td>
          <span *ngIf="!subj.loaded">Known</span>
          <span *ngIf="subj.loaded && !subj.running" class="text-primary">
            Loaded
          </span>
          <span *ngIf="subj.loaded && subj.running" class="text-success">
            Running
          </span>
        </td>
        <td>
          {{subj.lastLocalActionDescription}}
          at
          {{subj.lastLocalActionTime | date}}
        </td>
        <td *ngIf="users.debugMode">
          <em>Server:</em> {{subj.id}}
          <br>
          <em>Local:</em> {{subj.localId}}
        </td>
        <td *ngIf="provideAction">
          <button class="btn btn-primary p100" (click)="dialog.close(subj)">
            {{actionLabel}}
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <watchlist
    *ngIf="dialog.context.mode === 'watchlist'"
    [showTitle]="false"
    [asSelector]="true"
    [enforcedType]="dialog.context.onlyOfType"
    (selection)="select($event)">
  </watchlist>

  <div *ngIf="dialog.context.mode === 'search'" class="modal-body" #search>
    <div class="btn-group" style="margin: auto">
      <a
        class="btn btn-default"
        [class.active]="!search.showResults"
        (click)="search.showResults = false">
        Query
      </a>
      <a
        class="btn btn-default"
        [class.active]="search.showResults"
        (click)="search.showResults = true">
        Results
      </a>
    </div>
    <div *ngIf="!search.showResults">
      <search-panel
        [enforcedType]="dialog.context.onlyOfType"
        [unwrap]="true"
        (onSubmit)="search.showResults = true">
      </search-panel>
    </div>
    <div *ngIf="search.showResults">
      <search-results-table [asSelector]="true" (selection)="select($event)">
      </search-results-table>
    </div>
  </div>


  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default"
      (click)="dialog.dismiss()">
      OK
    </button>
  </div>
  `
})
export class SubjectSelectorModalComponent
  implements ModalComponent<SubjectSelectionContext>
{
  public provideAction : boolean = false;
  public actionLabel : string;
  public showNonLoaded : boolean = true;
  public subjects : Subject[];

  constructor (
    public dialog : DialogRef<SubjectSelectionContext>,
    public users : UserService
  )
  {
    this.subjects = dialog.context.list;
    if (dialog.context.actionLabel)
    {
      this.provideAction = true;
      this.actionLabel = dialog.context.actionLabel;
    }
    if (dialog.context.showNonLoaded !== undefined)
    {
      this.showNonLoaded = dialog.context.showNonLoaded;
    }
  }

  public select (subject : Subject) : void
  {
    if (subject)
    {
      this.dialog.close(subject);
    }
    else
    {
      this.dialog.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/subjects/subject-selector-modal.component.ts